import { InfotextDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/infotext-display-model';
import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { GlobalEnumsAceBenutzerrolle } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-benutzerrolle';
import { I18nService } from '@/core/services/i18nService';
import { StateService } from '@/core/services/state.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExtendedAuthenticationService } from '../authentication/services/extended-authentication.service';

let that: InfoComponent;
@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent {

  protected _portalKonfiguration: PortalkonfigurationDisplayModel;
  protected _showInfoTexteInSidebar: boolean = true;
  protected _infoContainer: InfotextDisplayModel | null;

  public get infoContainer(): InfotextDisplayModel | null{
    return that._infoContainer;
  }

  public get beschreibungAsHtml(): string {
    if (that.infoContainer && that.infoContainer.beschreibung && that.infoContainer.beschreibung != undefined)
      return this.languageservice.getCurrentLocalizedTextDisplayModel(that.infoContainer.beschreibung)?.text ?? "";
    return "";
  }

  public get IsVisible()
  {
    return (this.languageservice.getCurrentLocalizedTextDisplayModel(this._infoContainer?.beschreibung) || this.HasAdminrolle) && this._portalKonfiguration.infotexteInSidebarAnzeigen === true;
  }
  
  public set infoContainer(v: InfotextDisplayModel|null) {
    that._infoContainer = v;
  }

  public get HasAdminrolle() : boolean {
    return this.authenticationService.CurrentUser?.benutzerrolle == GlobalEnumsAceBenutzerrolle.Administrator;
  }

  constructor(public stateService: StateService, protected authenticationService: ExtendedAuthenticationService, protected route: ActivatedRoute, protected languageservice: I18nService) {
    that = this;
    that.stateService.addInfo$.subscribe(this.OnAdd);
    that.stateService.clearInfo$.subscribe(this.OnClear);

    this._portalKonfiguration = this.route.snapshot.parent?.data.portalkonfiguration;
  }

  public OnAdd(info: InfotextDisplayModel) {
   that.infoContainer = info;
  }

  public OnClear() {
    that.infoContainer = null;
   }
}
